











































































































import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { mapGetters } from 'vuex'
import { APP_NS } from '~/store/modules/shared/app/state'
import { defineComponent } from '@nuxtjs/composition-api'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(APP_NS, {
      domain: 'domain'
    }),
    icons() {
      return {
        check: faCheck
      }
    },
    accountCreationLink() {
      return this.$dep(LegacyUrlService).getRegisterUrl()
    },
    visible: {
      get() {
        return this.modelValue
      },
      set(value: boolean) {
        this.$emit('update:modelValue', value)
      }
    }
  }
})
